import { TupleDictionary } from '@/utils/tupleDictionary';

export enum PbiWorkspacesEnum {
  Neodash
}

export default class PbiDictWorkspaceId {
  constructor() {
    this._dictionary = new TupleDictionary<[PbiWorkspacesEnum.Neodash], string>();
    this._dictionary.set([PbiWorkspacesEnum.Neodash], '05ed788a-138b-49f3-9e68-ecb363bff037');
  }

  private readonly _dictionary: TupleDictionary<[PbiWorkspacesEnum], string>;

  get dictionary(): TupleDictionary<[PbiWorkspacesEnum], string> {
    return this._dictionary;
  }
}
